import { Region } from '../utils/commonInterfaces';
import Cookies from 'js-cookie';
import { getRegion } from '../components/regionWrapper';
import { getExportAxiosRequestByRegion } from '../utils/getExportAxiosRequestByRegion';

export const getApi = (api: string, info: any) => {
    const region = getRegion();
    const axios = getExportAxiosRequestByRegion(region as Region);
    return async ( _dispatch:any) => {
        try {
            if (region === Region.EG) {
            const token =Cookies.get('token');
                const { data } = await axios(api, {
                    ...info,
                    method: 'GET',
                headers:{
                    Authorization: `Bearer ${token}`
                }
            });
            return {
                payload: data
            };
            } else {
                console.log('se');
                const { data } = await axios(api, {
                    ...info,
                    method: 'GET',
                    headers: {
                        // Authorization header removed - backend reads from cookie
                    },
                    withCredentials: true // Important - enables automatic cookie transmission
                });
                return {
                    payload: data
                };
            }
        } catch (e) {
            return {
                error: true,
            };
        }
    }
}